export default __webpack_public_path__ + "static/media/property_654.740da9a2.png";